import React, { useMemo } from "react";
import { Link as RouterLink } from "react-router-dom";
import blogData from "../../blog/blog.json";
import { Typography, Paper, Box } from "@mui/material";

const BlogPostRow = ({ currentPostId, sx = {} }) => {
  // Filter out the current post
  const otherPosts = blogData.filter((post) => post.id !== currentPostId);

  // Pick a random post once per render
  const randomPost = useMemo(() => {
    if (otherPosts.length === 0) return null;
    const randomIndex = Math.floor(Math.random() * otherPosts.length);
    return otherPosts[randomIndex];
  }, [otherPosts]);

  if (!randomPost) return null;

  return (
    <Paper
      elevation={3}
      component={RouterLink}
      to={`/blog/${randomPost.id}`}
      sx={{
        mt: 3,
        p: 3,
        width: "100%",
        boxSizing: "border-box",
        cursor: "pointer",
        borderRadius: 2,
        textDecoration: "none",
        color: "inherit",
        display: "block",
        "&:hover": {
          boxShadow: 6,
          textDecoration: "none",
          opacity: 0.9,
        },
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: 600 }}>
          {randomPost.title}
        </Typography>
        <Typography variant="subtitle2" sx={{ fontWeight: 500, opacity: 0.6 }}>
          Read next →
        </Typography>
      </Box>

      <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1 }}>
        {randomPost.category}
      </Typography>
    </Paper>
  );
};

export default BlogPostRow;
